export default "__VITE_ASSET__CSJZaori__"